var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', '\n'], ['\n  margin-top: ', '\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  columns: auto ', ';\n  column-fill: balance;\n\n  .btn-group {\n    display: block;\n    column-span: all;\n  }\n'], ['\n  columns: auto ', ';\n  column-fill: balance;\n\n  .btn-group {\n    display: block;\n    column-span: all;\n  }\n']);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ButtonGroup, Input, FormGroup, Label, Button } from 'reactstrap';
import styled from 'styled-components';
import { compact } from 'lodash';
var BatchButton = styled(Button)(_templateObject, function (p) {
  return p.inline && '-5px';
});
var SCG = styled.div(_templateObject2, function (p) {
  return p.columns;
});
var CordataCheckboxGroup = function CordataCheckboxGroup(_ref) {
  var id = _ref.id,
    value = _ref.value,
    options = _ref.options,
    error = _ref.error,
    touched = _ref.touched,
    disabled = _ref.disabled,
    inline = _ref.inline,
    className = _ref.className,
    _onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    getOptionLabel = _ref.getOptionLabel,
    getOptionValue = _ref.getOptionValue,
    batch = _ref.batch,
    components = _ref.components,
    columns = _ref.columns,
    props = _objectWithoutProperties(_ref, ['id', 'value', 'options', 'error', 'touched', 'disabled', 'inline', 'className', 'onChange', 'onBlur', 'getOptionLabel', 'getOptionValue', 'batch', 'components', 'columns']);
  var canColumnize = columns && !inline;
  var CG = canColumnize ? SCG : 'div';
  var classesRadioAndCheckbox = classnames(className, 'h-100', {
    'is-invalid text-danger': error && touched
  });
  var batchButtonBaseProps = {
    inline: inline,
    type: 'button',
    color: 'link',
    size: 'sm'
  };
  var handleDeselect = function handleDeselect() {
    return _onChange([].concat(_toConsumableArray(value.filter(function (v) {
      return v.disabled;
    }))));
  };
  var handleSelect = function handleSelect() {
    return _onChange([].concat(_toConsumableArray(options.filter(function (o) {
      return !o.disabled;
    }))));
  };
  return React.createElement(CG, {
    className: classesRadioAndCheckbox,
    columns: columns
  }, options.map(function (o) {
    return React.createElement(FormGroup, {
      key: (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' ? id + '-' + getOptionValue(o) : o,
      check: true,
      inline: inline,
      className: (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o.hidden && 'd-none'
    }, React.createElement(Input, {
      id: id + '-' + ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' ? getOptionValue(o) : o),
      type: 'checkbox',
      value: (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' ? getOptionValue(o) : o,
      checked: (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' ? value.map(function (v) {
        return getOptionValue(v);
      }).includes(getOptionValue(o)) : value.includes(o),
      onChange: function onChange(e) {
        var val = [];
        if ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' ? value.map(function (v) {
          return getOptionValue(v);
        }).includes(e.target.value) : value.includes(e.target.value)) {
          value.splice((typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' ? value.map(function (v) {
            return getOptionValue(v);
          }).indexOf(e.target.value) : value.indexOf(e.target.value), 1);
        } else {
          val.push(o);
        }
        return _onChange(compact([].concat(val, _toConsumableArray(value))));
      },
      disabled: (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && (o.hidden || o.disabled) || disabled,
      noValidate: true
    }), React.createElement(Label, {
      'for': id + '-' + ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' ? getOptionValue(o) : o),
      check: true
    }, components && components.Option ? React.createElement(components.Option, _extends({
      option: o
    }, props)) : (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' ? getOptionLabel(o) : o));
  }), !disabled && batch && React.createElement(ButtonGroup, {
    className: 'ml-n2'
  }, React.createElement(BatchButton, _extends({
    disabled: disabled
  }, batchButtonBaseProps, {
    onClick: handleSelect
  }), 'Select All'), React.createElement(BatchButton, _extends({
    disabled: disabled
  }, batchButtonBaseProps, {
    onClick: handleDeselect
  }), 'Deselect All')));
};
CordataCheckboxGroup.propTypes = {
  id: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  touched: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.bool, PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  className: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  batch: PropTypes.bool,
  inline: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  components: PropTypes.shape({
    Option: PropTypes.func
  }),
  columns: PropTypes.number
};
CordataCheckboxGroup.defaultProps = {
  error: undefined,
  touched: false,
  className: undefined,
  value: [],
  options: undefined,
  required: false,
  disabled: false,
  batch: true,
  inline: false,
  getOptionLabel: function getOptionLabel(o) {
    return o.label;
  },
  getOptionValue: function getOptionValue(o) {
    return o.value;
  },
  components: undefined,
  columns: undefined
};
export default CordataCheckboxGroup;